import FetchClient, { type ApiResponse } from "./FetchClient";
import type { FavoriteProduct } from "./FavoritesService";

// A favorite tagged with the retailer it belongs to, from GET /favorites/all.
export interface GlobalFavorite extends FavoriteProduct {
  retailer: string;
}

export interface GlobalFavoritesResponse {
  favorites: GlobalFavorite[];
}

// Lives under ["favorites", "list"] so blanket favorites invalidations also
// refresh the global view; hooks that use retailer predicates invalidate it
// explicitly.
export const globalFavoritesQueryKey = ["favorites", "list", "global-all"] as const;

export const getAllFavorites = async (): Promise<GlobalFavorite[]> => {
  const response: ApiResponse<GlobalFavoritesResponse> = await FetchClient.get("/favorites/all");
  return response.data.favorites || [];
};

export const clearAllFavorites = async (): Promise<void> => {
  await FetchClient.delete("/favorites/all");
};
